import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import styles from './surveySchemaPartList.module.css';
import { routes } from '../../constants';
import { getCompiledPath } from '../../util';

const ExtraSurveyPartListRow = ({
  surveyPartId, title, code, description, onSelectSchemaPart, selectable,
  disabled, status, translate: t
}) => {
  const rowClasses = [
    selectable && styles.borders,
    styles.row
  ].filter(Boolean).join(' ');

  const titleLink = (selectable)
    ? title
    : <Link to={getCompiledPath(routes.surveySchemas.extraSurveyParts.surveyPart.index, { surveyPartId })}>{title}</Link>;

  const onClick = (event) => {
    if (selectable) {
      onSelectSchemaPart(event);
    }
  };

  return (
    <tr className={rowClasses}>
      {selectable
        && (
        <td>
          <button
            type="button"
            className={`button icon--plus ${disabled ? 'disabled' : ''}`}
            aria-label={`${t('common.add')} ${title} ${code}`}
            onClick={onClick}
            disabled={disabled}
            data-cy="add-extra-question-plus-button"
          />
        </td>
        )}
      <td data-cy="survey-additional-question-list-row-link">{titleLink}</td>
      <td data-cy="survey-additional-question-list-row-code">{code}</td>
      <td data-cy="survey-additional-question-list-row-description">{description}</td>
      <td data-cy="survey-additional-question-list-row-status">{status}</td>
      { selectable && <td />}
    </tr>
  );
};

const {
  string, func, bool, number, node
} = PropTypes;

ExtraSurveyPartListRow.propTypes = {
  surveyPartId: number.isRequired,
  title: string.isRequired,
  code: string.isRequired,
  description: string.isRequired,
  selectable: bool.isRequired,
  onSelectSchemaPart: func.isRequired,
  disabled: bool,
  status: node.isRequired,
  translate: func.isRequired
};

ExtraSurveyPartListRow.defaultProps = {
  disabled: false
};

export default ExtraSurveyPartListRow;
